module.exports = __webpack_public_path__ + "media/table_service.37bef801.webm";